import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProductService } from 'src/app/services/product.service';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import {ProductDto} from "../../entities/product/ProductDto";

@Component({
  selector: 'all-tests',
  templateUrl: './all-tests.component.html',
  styleUrls: ['./all-tests.component.scss']
})
export class AllTestsComponent implements OnInit, OnDestroy {

  title: string = 'Comprehensive Lab Test Catalog | Grassroots Labs Full Listing';
  defaultTitle: string = 'Grassroots Labs - Blood Tests are Expensive. We fix that.';
  metaDescription: string = `Browse our full listing of lab tests to find exactly what you need for your health journey.
  At Grassroots Labs, we offer a complete range of affordable, transparently-priced diagnostics, supported by healthcare providers.`;

  page: number = 1;
  tests: ProductDto[] = [];
  imageURL: string = environment.baseIconUrl;
  testsCount: number = 0;

  constructor(
    private readonly productService: ProductService,
    private metaService: Meta,
    private titleService: Title,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.setPageMetadata();
    this.loadProducts();
  }

  ngOnDestroy(): void {
    this.resetMetadata();
  }

  private loadProducts(): void {
    this.productService.findProducts('', 10, 0).subscribe(result => {
      this.tests = result.entities;
      this.testsCount = result.totalCount;
    });
  }

  testNavigate(test: ProductDto): void {
    this.router.navigateByUrl(`product/${test.slug}`);
  }

  allTestsNavigate(): void {
    this.router.navigate(['/all']);
  }


  mainPageNavigate(): void {
    this.router.navigate(['/']);
  }

  onPageChange(currentPage: number): void {
    const limit = 10;
    const offset = (currentPage - 1) * limit;
    this.productService.findProducts('', limit, offset).subscribe(result => {
      this.tests = result.entities;
      this.testsCount = result.totalCount;
    });
    scroll(0, 0);
  }

  // Metadata functions
  private resetMetadata(): void {
    this.titleService.setTitle(this.defaultTitle);
    this.metaService.removeTag('name="description"');
  }

  private setPageMetadata(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTag({ name: 'description', content: this.metaDescription });
  }
}
